import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ValueCode } from '@ridango/components/lib/purchase/purchase.model';
import { TranslateService } from '@ngx-translate/core';
import { ApplicationFacade } from '@ridango/components/lib/application/+state/application.facade';

@Component({
    selector: 'gl-delete-value-code-modal',
    templateUrl: './delete-value-code-modal.component.html',
    styleUrls: ['./delete-value-code-modal.component.scss']
})
export class DeleteValueCodeModalComponent {
    @Input() code: ValueCode;
    public currentLanguage = this.translate.currentLang;
    public assetsPath$ = this.applicationFacade.assetsPath$;

    constructor(
        private modalCtrl: ModalController,
        private translate: TranslateService,
        private applicationFacade: ApplicationFacade
    ) {}

    public async cancel(): Promise<void> {
        await this.modalCtrl.dismiss(null, 'cancel');
    }

    public async handleDeleteClick() {
        await this.modalCtrl.dismiss(true, 'cancel');
    }
}
